//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { addDays } from "../utils/functions";
import { OverlayWrapper } from "./OverlayRouter";
import { useMedia } from "./ui-elements/SizeDetector";
import {
  ACCEPT_ACTION,
  BOOK_LESSONS_ACTION,
  CHAT_ACTION,
  CONTACT_CLIENT_ACTION,
  DECLINE_ACTION,
  SHOW_EARNINGS_ACTION,
  SUBMIT_FEEDBACK_ACTION,
  VIEW_CALL_TIPS_ACTION,
} from "../stores/jobs/utils/request";
import AcceptRequest from "./AcceptRequest";
import ChatWithSupport from "./ChatWithSupport";
import ContactClientsTips from "./ContactClientTips";
import DeclineRequest from "./DeclineRequest";
import EarningsBreakdown from "./EarningsBreakdown";
import ScheduleLessons from "./ScheduleLessons";
import SubmitFeedback from "./SubmitFeedback";

const ModalComponents = observer(
  ({
    isSubmitting,
    handleAction,
    weeklySchedule,
    stopDate,
    clientName,
    action,
    onClose,
    booking,
    tutorInfo,
    error,
  }: {
    isSubmitting: boolean;
    handleAction: any;
    weeklySchedule: any;
    stopDate: any;
    clientName: string;
    action: string;
    onClose: () => void;
    booking: any;
    tutorInfo: any;
    error: any;
  }) => {
    return (
      <Box py={5}>
        {action === SHOW_EARNINGS_ACTION && (
          <EarningsBreakdown
            billingInfo={booking.billingInfo}
            lessonInfo={booking.lessonInfo}
            students={booking.students}
          />
        )}

        {action === ACCEPT_ACTION && (
          <AcceptRequest
            isSubmitting={isSubmitting}
            onClick={handleAction}
            stopDate={stopDate}
            clientName={clientName}
            error={error}
          />
        )}
        {action === DECLINE_ACTION && (
          <DeclineRequest
            isSubmitting={isSubmitting}
            onClick={handleAction}
            stopDate={stopDate}
            onCancelDecline={onClose}
            clientName={clientName}
            error={error}
          />
        )}
        {action === CHAT_ACTION && (
          <ChatWithSupport
            assignedSupport={booking.assignedSupport}
            requestSLUG={booking.requestSLUG}
            tutorInfo={tutorInfo}
            clientName={clientName}
          />
        )}
        {action === CONTACT_CLIENT_ACTION && (
          <ContactClientsTips
            requestStatus={booking.requestStatus}
            onClose={onClose}
            onSubmit={handleAction}
          />
        )}

        {action === BOOK_LESSONS_ACTION && (
          <ScheduleLessons
            weeklySchedule={weeklySchedule}
            isSubmitting={isSubmitting}
            booking={booking}
            onSubmit={handleAction}
          />
        )}

        {action === SUBMIT_FEEDBACK_ACTION && (
          <SubmitFeedback
            isSubmitting={isSubmitting}
            onClick={handleAction}
            clientName={clientName}
            requestStatus={booking.requestStatus}
          />
        )}
      </Box>
    );
  },
);

type Props = {
  onRespond: (...args: any[]) => void;
  action: string;
  isSubmitting: boolean;
  weeklySchedule: any;
  tutorInfo: any;
  booking: any;
  store: any;
  isOpen: boolean;
  error: any;
  onClose: () => void;
};

const JobActionsModal = observer(
  ({
    onRespond,
    action,
    isSubmitting,
    weeklySchedule,
    tutorInfo,
    booking,
    store,
    isOpen,
    error,
    onClose,
  }: Props) => {
    const isMobile = useMedia("(max-width: 420px)");
    const client = booking.customerInfo;
    const clientName = `${client.title} ${client.firstName}`;
    const stopDate = addDays(booking.dateCreated, 1);
    const handleAction = (response, closeModal) => {
      let responseDate = new Date();
      let bookingDate = new Date(booking.dateCreated);
      const responseTime = responseDate.getTime() - bookingDate.getTime();
      return onRespond({ ...response, responseTime }, closeModal);
    };

    const headerText = () => {
      if (action === ACCEPT_ACTION) return "Accept request";
      if (action === DECLINE_ACTION) return "Decline request";
      if (action === CHAT_ACTION) return "Contact support";
      if (action === CONTACT_CLIENT_ACTION) return "Tips when calling clients";
      if (action === VIEW_CALL_TIPS_ACTION) return "Helpful call tips";
      if (action === SUBMIT_FEEDBACK_ACTION) return "Call feedback";
      if (action === BOOK_LESSONS_ACTION) return "Schedule your lessons";
      if (action === SHOW_EARNINGS_ACTION)
        return (
          <Box>
            <Text>Earnings breakdown</Text>
            <Text fontWeight="normal" fontSize={["sm", "md"]} opacity={0.8}>
              Prices and earnings are non-negotiable
            </Text>
          </Box>
        );
    };

    if (isMobile) {
      return (
        <OverlayWrapper path="/modal">
          <Drawer
            isOpen={isOpen}
            placement="bottom"
            isFullHeight
            size="full"
            // scrollBehavior="inside"
            onClose={onClose}
          >
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader px={4} borderBottomWidth="2xs">
                {headerText()}
              </DrawerHeader>

              <DrawerBody px={4}>
                <ModalComponents
                  action={action}
                  isSubmitting={isSubmitting}
                  handleAction={handleAction}
                  weeklySchedule={weeklySchedule}
                  stopDate={stopDate}
                  clientName={clientName}
                  onClose={onClose}
                  booking={booking}
                  tutorInfo={tutorInfo}
                  error={error}
                />
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </OverlayWrapper>
      );
    }
    return (
      <OverlayWrapper path="/modal">
        <Modal size="lg" isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent rounded="fbRadius" overflow="hidden">
            <ModalHeader borderBottomWidth="2xs" fontWeight="bold">
              {headerText()}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <ModalComponents
                action={action}
                isSubmitting={isSubmitting}
                weeklySchedule={weeklySchedule}
                handleAction={handleAction}
                stopDate={stopDate}
                clientName={clientName}
                onClose={onClose}
                booking={booking}
                tutorInfo={tutorInfo}
                error={error}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      </OverlayWrapper>
    );
  },
);

export default JobActionsModal;
